import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';

/**
 * Header class.
 */
export default class Filter extends withBreakpointObserver(Base) {
  /**
   * App config.
   * @returns {object}
   */
  static config = {
    name: 'Filter',
    refs: ['btn', 'panel', 'close'],
    options: {
      activeBreakpoints: {
        type: String,
        default: 'xxs xs s m',
      },
    },
  };

  /**
   * Log a nice message when app is ready.
   * @returns {void}
   */
  mounted() {
    this.body = document.querySelector('body');
  }

  /**
   * Click on filter button
   * @returns {void}
   */
  onBtnClick() {
    this.openFilter();
  }

  /**
   * Click on cross
   * @returns {void}
   */
  onCloseClick() {
    this.closeFilter();
  }

  /**
   * Add class to body and open filter panel with CSS
   * @returns {void}
   */
  openFilter() {
    this.body.classList.add('open-filter');
  }

  /**
   * Remove class to body and close filter panel with CSS
   * @returns {void}
   */
  closeFilter() {
    this.body.classList.remove('open-filter');
  }

  /**
   * Remove class to body and close filter panel when jstoolkit is detroyed
   * @returns {void}
   */
  destroyed() {
    this.closeFilter();
  }
}
